export enum SortTypes {
  ASC = 'asc',
  DESC = 'desc',
  DEFAULT = 'default',
}
